import { boardApi } from '$lib/api/board';
import type { BoardCard } from '$lib/types';
import { boardViewIsAssignee } from './boardSeen';

import { reportedBoardViews as reported, boardViewSessionGeneration } from './boardViewSession';
type View = { card: BoardCard; userId?: number };

// Only cards actually in the viewport of a visible document qualify. A short
// dwell avoids counting cards merely scrolled past or hidden mobile columns.
export function trackBoardView(node: HTMLElement, initial: View) {
  let view = initial;
  let visible = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  function schedule() {
    clearTimeout(timer);
    if (!visible || document.visibilityState !== 'visible' || !boardViewIsAssignee(view.card, view.userId)) return;
    const key = `board-seen:${view.userId}:${view.card.id}`;
    if (reported.has(key)) return;
    try { if (sessionStorage.getItem(key)) return; } catch { /* In-memory fallback. */ }
    const generation = boardViewSessionGeneration;
    timer = setTimeout(() => {
      if (generation !== boardViewSessionGeneration) return;
      if (reported.has(key)) return;
      reported.add(key);
      try { sessionStorage.setItem(key, '1'); } catch { /* In-memory fallback. */ }
      void boardApi.recordView(view.card.id, 'board_open').catch(() => {});
    }, 500);
  }
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting && entry.intersectionRatio > 0;
    schedule();
  });
  observer.observe(node);
  document.addEventListener('visibilitychange', schedule);
  return {
    update(next: View) { view = next; schedule(); },
    destroy() { clearTimeout(timer); observer.disconnect(); document.removeEventListener('visibilitychange', schedule); }
  };
}
